import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICONSPRITE_PATH } from '../app.constants';
import { AppService } from './app.service';

@Injectable()
export class IconspriteService {

    constructor(private http: HttpClient, private appService: AppService) {}

    public getIconSprite(): Observable<string> {
        return this.http.get(`${ICONSPRITE_PATH}?${this.appService.hash}`, {
            responseType: 'text'
        });
    }
}
